import { makeStyles } from '@material-ui/styles';
import { format, isPast, isValid } from 'date-fns';
import React from 'react';

import { Colors } from 'src/common/ui/base';

const useStyles = makeStyles({
  runOutLabel: {
    '&.past': {
      alignItems: 'center',
      alignSelf: 'flex-start',
      backgroundColor: Colors.Red1,
      border: `1px solid ${Colors.Red4}`,
      borderRadius: 4,
      color: Colors.Red4,
      display: 'flex',
      fontSize: 14,
      fontWeight: 600,
      letterSpacing: 0.201,
      lineHeight: '100%',
      padding: '2px 4px',
    },
  },
});

export const MedicationRunOutLabel = (props: { runOutDate?: Date }) => {
  const classes = useStyles();
  const classList = [classes.runOutLabel];

  if (!props.runOutDate || !isValid(props.runOutDate)) {
    return <span>--</span>;
  }

  if (isPast(props.runOutDate)) {
    classList.push('past');
  }

  return <span className={classList.join(' ')}>{format(props.runOutDate, 'M/d/yyyy')}</span>;
};
